import {
  getRequestClient,
  postHostedIdentifySessionChallenge,
  postHostedIdentifySessionChallengeVerify,
} from '@onefootprint/fetch-hosted';
import { getLogger } from '@/idv2/utils/logger';

const { logInfo } = getLogger({ name: 'identify-sna' });

export const runSnaChallenge = async (identifyToken: string) => {
  const headers = { 'X-Fp-Authorization': identifyToken };
  const { data } = await postHostedIdentifySessionChallenge({
    headers,
    body: { challengeKind: 'sna' },
  });
  const snaLink = data.challengeData.snaLink;
  if (!snaLink) {
    throw new Error('No SNA link found');
  }
  const snaClient = getRequestClient({
    baseUrl: snaLink,
    disableBodySnakeCaseConversion: true,
    disableResponseCamelCaseConversion: true,
  });
  // The carrier response body is unreviewed third-party data.
  const snaResponse = await snaClient.post({ url: '' });
  logInfo('SNA response received', { hasResponse: snaResponse.data != null });

  await postHostedIdentifySessionChallengeVerify({
    headers,
    body: { challengeResponse: '' },
  });
};
